/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { string, shape, object, array, func, bool } from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'clsx';

import { getCompany as getCompanyAction } from 'actions/company';

import styles from './staff-list.scss';

/**
 * This is the StaffList component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class StaffList extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    auth: shape({
      token: string.isRequired,
    }).isRequired,
    getCompany: func.isRequired,
    company: object.isRequired,
    companyId: string,
    staff: array,
    wide: bool,
  };

  static defaultProps = {
    companyId: '',
    staff: [],
    wide: false,
  };

  componentDidMount() {
    const {
      auth: { token },
      companyId,
      company,
      getCompany,
    } = this.props;

    // Should we load company?
    const loadCompany = companyId ? company.company_id !== companyId : false;

    if (loadCompany) {
      getCompany(token, companyId);
    }
  }

  /**
   * Render StaffList.
   *
   * @return {Object}
   */
  render() {
    const { company, staff, wide } = this.props;
    const items = company.staff ? company.staff : staff;

    return (
      <section
        className={classNames(styles.wrapper, {
          [styles.wide]: wide,
        })}
      >
        {items.map(({ slug, title, fullname }) => (
          <article key={slug} className={styles.item}>
            <div className={styles.card}>
              <h2>{title}</h2>
              <h1>{fullname}</h1>
            </div>
          </article>
        ))}
      </section>
    );
  }
}

export default connect(
  ({ auth, company }) => ({ auth, company }),
  {
    getCompany: getCompanyAction,
  }
)(StaffList);
